enum StorageKey {
	REFRESH_TOKEN = 'refreshToken',
	REMEMBER = 'remember',
	USER = 'user',
	ADMIN = 'admin',
	CONTENT = 'content',
}

export default StorageKey;
